function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import AuthClient from './client';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { routes } from '@shared/routerHistory';
import { logger } from '@src/logger';
import { stringifyError } from '@shared/utils/errorUtils';
export const postRedirect = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*() {
        try {
            const tokenResponse = yield AuthClient.getInstance().handleRedirectPromise();
            if (tokenResponse) {
                const { state } = tokenResponse;
                logger.info(JSON.stringify({
                    state
                }), {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.AuthRedirectSucceed
                });
            } else if (getWindow().location.pathname === routes.redirect.getPath()) {
                // User navigated to redirect route and didn't come from AAD, so will be redirected to homepage as a fallback
                const fallbackRoute = routes.home.getPath();
                logger.warning(JSON.stringify({
                    to: fallbackRoute
                }), {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.AuthRedirectNotFromAAD
                });
                getWindow().location.href = fallbackRoute;
            }
        } catch (error) {
            logger.error(stringifyError(error), {
                action: Constants.Telemetry.Action.Login,
                actionModifier: Constants.Telemetry.ActionModifier.AuthRedirectFailed,
                error
            });
        }
    });
    return function postRedirect() {
        return _ref.apply(this, arguments);
    };
}();
